export enum EMPTY_VIDEO_LIST_MESSAGE {
  CLIPS = 'Op dit moment zijn er geen clips beschikbaar van dit seizoen',
  EPISODES = 'Op dit moment zijn er geen afleveringen beschikbaar van dit seizoen'
}
